import React from 'react';
import { DevelopmentRoleType, TechStackType, UserCareerPathType, UserExperienceLevelType } from 'types';

const PreferenceTab = ({
	text,
	onSelect,
	isSelected,
	roundTemplateId,
	isMock,
	isDisabled,
	isComingSoon,
}: {
	text: string;
	isSelected: boolean;
	onSelect: (text: string) => void;
	roundTemplateId?: string;
	isMock?: boolean;
	isDisabled?: boolean;
	isComingSoon?: boolean;
}) => {
	// TODO NITANSH: Add icon and match word
	let tabIcon = null;
	let finalText: React.ReactNode | string = isMock
		? text
		: text?.split(/(?=[A-Z])/).map((word, index) => (
				<span key={index} className="capitalize">
					{word}{' '}
				</span>
		  ));

	switch (text) {
		case 'softwareDevelopment':
			finalText = 'Software Development';
			tabIcon = `/assets/preferenceIcons/softwareDevelopment.svg`;
			break;
		case 'dataAnalytics':
			finalText = 'Data Analytics';
			tabIcon = `/assets/preferenceIcons/dataAnalytics.svg`;
			break;
		case 'sdet':
			finalText = 'Software Testing';
			tabIcon = `/assets/preferenceIcons/sdet.png`;
			break;
		case 'frontend':
			finalText = 'Frontend Developer';

			break;
		case 'backend':
			finalText = 'Backend Developer';

			break;
		case 'fullStack':
			finalText = 'Full Stack Developer';

			break;
		case 'mern':
			finalText = 'MERN Stack';
			tabIcon = `/assets/preferenceIcons/mern.svg`;

			break;
		case 'django':
			finalText = 'Django';
			tabIcon = `/assets/preferenceIcons/django.svg`;
			break;
		case 'java':
			finalText = 'Java';
			tabIcon = `/assets/preferenceIcons/java.svg`;
			break;
		case 'node':
			finalText = 'NodeJs';
			tabIcon = `/assets/preferenceIcons/node.svg`;
			break;
		case 'react':
			finalText = 'ReactJs';
			tabIcon = `/assets/preferenceIcons/react.svg`;
			break;
		case 'angular':
			finalText = 'AngularJs';
			break;
		case TechStackType.C_SHARP_ENGINEER:
			finalText = 'C# Engineer';
			break;
		case UserExperienceLevelType.FINAL_YEAR_STUDENT:
			finalText = 'Final Year Student';
			break;
		case UserExperienceLevelType.FRESHER:
			finalText = 'Freshers';
			break;
		case UserExperienceLevelType.OneToTwoYears:
			finalText = '1-2 Years';
			break;
		case UserExperienceLevelType.TwoPlusYears:
			finalText = '2+ Years';
			break;
		case UserCareerPathType.TECH_SUPPORT:
			finalText = 'Tech Support';
			break;
		case UserCareerPathType.BD_EXECUTIVE:
			finalText = 'BD Executive';
			break;
		case UserCareerPathType.DEV_OPS:
			finalText = 'DevOps';
			break;
		case UserCareerPathType.MATH_ANNOTATIONS_EXPERT:
			finalText = 'Math Annotations Expert';
			break;
		case UserCareerPathType.PRODUCT:
			finalText = 'Product';
			break;
		case UserCareerPathType.SITE_RELIABILITY_ENGINEER:
			finalText = 'Site Reliability Engineer';
			break;
		case UserCareerPathType.HUMAN_RESOURCES:
			finalText = 'Human Resources';
			break;
		case UserCareerPathType.SALES:
			finalText = 'Sales';
			break;
		case UserCareerPathType.REACT_NATIVE:
			finalText = 'React Native';
			break;
		case DevelopmentRoleType.TWO_TO_FOUR_YEARS:
			finalText = 'SDE-2 (2-4 years exp.)';
			break;
		case DevelopmentRoleType.FOUR_PLUS_YEARS:
			finalText = 'Senior Software Engineer (4+ years exp.)';
			break;
		case DevelopmentRoleType.DATA_ANALYST:
			finalText = 'Data Analyst';
			break;
		case DevelopmentRoleType.DATA_SCIENTIST:
			finalText = 'Data Scientist';
			break;
		case DevelopmentRoleType.PRODUCT_MANAGER:
			finalText = 'Product Manager';
			break;
		case DevelopmentRoleType.SALES_B2B:
			finalText = 'Sales B2B';
			break;
		case DevelopmentRoleType.SALES_B2C:
			finalText = 'Sales B2C';
			break;
		case DevelopmentRoleType.HR_MANAGER:
			finalText = 'HR Manager';
			break;
		case DevelopmentRoleType.SENIOR_QA_ENGINEER:
			finalText = 'Senior QA Engineer';
			break;
		case DevelopmentRoleType.SENIOR_HASKELL_ENGINEER:
			finalText = 'Senior Haskell Engineer';
			break;
		case DevelopmentRoleType.SENIOR_REACT_NATIVE_DEVELOPER:
			finalText = 'Senior React Native Developer';
			break;
	}

	return (
		<>
			<button
				onClick={() => {
					if (isDisabled) return;
					onSelect(isMock && roundTemplateId ? roundTemplateId : text);
				}}
				className={`relative ${
					isDisabled ? 'cursor-not-allowed' : 'cursor-pointer'
				} px-[12px] py-[8px] border rounded-[8px]
		${isSelected ? 'bg-[#18222D] border-[#3E7BFA] text-[#fff]' : 'bg-[#FFFFFF] border-[#E5E7EB]'}
		flex items-center gap-[8px]`}
			>
				{/* convert camelCase to proper word
			first letter of each word is capitalized */}
				{tabIcon ? <img src={tabIcon} alt={'tab icon'} className="w-[24px] h-[24px]" /> : null}
				{finalText}

				{isComingSoon && (
					<div className="absolute top-[-8px] right-[-4px] px-[2px] py-[2px]  bg-[#FDED72] rounded-[12px] text-[8px] text-[#555770] leading-[10px] font-[500]">
						Coming Soon
					</div>
				)}
			</button>
		</>
	);
};

export default PreferenceTab;
